import { vars } from '@repo/config';
import type { IUser } from '../types/i-user';
import type { IUsersListResponse } from '../types/i-users-list-response';
import { fetchGetWithRetry } from './helper';

export async function fetchUserById(cookieHeader: string, userId: string): Promise<IUser | null> {
  const usersUrl = new URL('/api/auth/admin/list-users', vars.url.identityUrl);
  usersUrl.searchParams.set('filterField', 'id');
  usersUrl.searchParams.set('filterValue', userId);
  usersUrl.searchParams.set('filterOperator', 'eq');

  const response = await fetchGetWithRetry(usersUrl.toString(), cookieHeader);

  if (!response.ok) {
    return null;
  }

  const data = (await response.json()) as IUsersListResponse;
  return data.users[0] ?? null;
}
